import { DisableWhen, EnableWhen, ValidationObject } from 'src/interfaces/utility-interfaces';

export class BaseInput<T> {
  value: T;
  linkId: string;
  label: string;
  required: boolean;
  controlType: string;
  enableWhen: EnableWhen[];
  disableWhen: DisableWhen[];
  enableBehavior: string;
  show: boolean;
  readonly: boolean;
  validation: ValidationObject;
  halfLine: boolean;
  disabled: boolean;
  invalid: boolean;
  warning: boolean;
  errorMsg: string;
  warningMsg: string;
  related: string;
  removed: boolean;
  leftIdent: boolean;
  fhirResourceId?: string;
  dataMissingReason?: string;

  constructor(options: {
    value?: T,
    linkId?: string,
    label?: string,
    required?: boolean,
    controlType?: string,
    enableWhen?: EnableWhen[],
    disableWhen?: DisableWhen[],
    enableBehavior?: string,
    show?: boolean,
    readonly?: boolean,
    validation?: ValidationObject,
    halfLine?: boolean,
    disabled?: boolean,
    invalid?: boolean;
    warning?: boolean;
    errorMsg?: string;
    warningMsg?: string;
    related?: string;
    removed?: boolean;
    leftIdent?: boolean;
    dataMissingReason?: string;
  } = {}) {
    this.value = options.value;
    this.linkId = options.linkId || '';
    this.label = options.label || '';
    this.required = options.required;
    this.controlType = options.controlType || '';
    this.enableWhen = options.enableWhen || [];
    this.disableWhen = options.disableWhen || null;
    this.enableBehavior = options.enableBehavior || '';
    this.show = options.show || false;
    this.readonly = options.readonly || false;
    this.halfLine = options.halfLine || false;
    this.disabled = options.disabled || false;
    this.invalid = options.invalid || false;
    this.warning = options.warning || false;
    this.errorMsg = options.errorMsg || '';
    this.warningMsg = options.warningMsg || '';
    this.related = options.related || '';
    this.removed = options.removed || false;
    this.leftIdent = options.leftIdent || false;
    this.dataMissingReason = options.dataMissingReason || '';
  }
}
